import { Col, H1, P, PerkTile, Row, Section, Wrapper } from '@ahmdigital/ui';
import { map } from 'lodash/fp';

import faqImage from '../../images/faq.svg';
import scamEmailImage from '../../images/laptop.svg';
import scamTextImage from '../../images/phone.svg';
import securePasswordImage from '../../images/secure-password.svg';
import styles from './styles.module.sass';

const BASE_TILE = {
  cta: {
    isLink: true,
    title: <P looksLike="h4">Learn more</P>,
    to: '#',
  },
  image: {
    alt: '',
    src: '',
  },

  name: 'How to spot scam text messages',
};

const tiles = [
  {
    ...BASE_TILE,
    cta: {
      ...BASE_TILE.cta,
      title: <P looksLike="h5">How to spot scam text messages</P>,
      to: 'https://help.ahm.com.au/hc/en-us/articles/9483852432399',
    },
    image: {
      ...BASE_TILE.image,
      src: scamTextImage.src,
    },
    name: 'Scam text messages come in many different forms',
  },
  {
    ...BASE_TILE,
    cta: {
      ...BASE_TILE.cta,
      title: <P looksLike="h5">How to spot scam emails</P>,
      to: 'https://help.ahm.com.au/hc/en-us/articles/9483823112975',
    },
    image: {
      ...BASE_TILE.image,
      src: scamEmailImage.src,
    },
    name: "Don't get fishing and phishing mixed up",
  },
  {
    ...BASE_TILE,
    cta: {
      ...BASE_TILE.cta,
      title: <P looksLike="h5">Learn more about safe online practices</P>,
      to: 'https://help.ahm.com.au/hc/en-us/articles/9483885352463',
    },
    image: {
      ...BASE_TILE.image,
      src: securePasswordImage.src,
    },
    name: 'Top tips for creating a secure password',
  },
  {
    ...BASE_TILE,
    cta: {
      ...BASE_TILE.cta,
      title: <P looksLike="h5">Frequently asked questions</P>,
      to: 'https://help.ahm.com.au/hc/en-us/articles/9483812407311',
    },
    image: {
      ...BASE_TILE.image,
      src: faqImage.src,
    },
    name: "We've got the answers to common queries",
  },
];

const RelatedTopicsTiles = () => (
  <Section variant={['marginTopSpacer4', 'marginBottomSpacer4']}>
    <H1 looksLike="h2" variant={['marginBottomSpacer4', 'center']}>
      Related topics
    </H1>
    <Wrapper isFullWidthMobile>
      <Row>
        {map(
          (tile) => (
            <Col variant={['marginBottomSpacer9']} df={6} sm={12}>
              <PerkTile className={styles.centeredOnMobile} {...tile} textVariant={['regular']} />
            </Col>
          ),
          tiles,
        )}
      </Row>
    </Wrapper>
  </Section>
);

export default RelatedTopicsTiles;
